module.exports = __webpack_public_path__ + "img/settings.a363af57.svg";